import React, { Component} from "react";
import Typical from "react-typical";
import Form from "./Form";

export default class Contact extends Component {
  contact_reason = [];

  render() {
    if (this.props.resumeContact && this.props.resumeBasicInfo) {
      var sectionName = this.props.resumeBasicInfo.section_name.contact;
      this.contact_reason = this.props.resumeContact.contact_reason
        .map((x) => [x, 1500])
        .flat();
    }
    const ContactTypeAnimation = React.memo(
      () => {
        return (
          <Typical
            className="contact-reason-styles"
            steps={this.contact_reason}
            loop={50}
          />
        );
      },
      (props, prevProp) => true
    );

    return (
      <section id="contact">
        <div className="col-md-12">
            <h1 className="section-title" style={{ color: "black" }}>
              <span className="text-black" style={{ textAlign: "center" }}>
                {sectionName}
              </span>
          </h1>
          <div className="row center mx-auto mb-5">
            {/* <div id="col-md-8 center"> */}
            <div className="col-md-5 mb-5 center">
            <div className="col-md-10">
              <div className="card">
                <div className="card-header">
                  <span
                    className="iconify"
                    data-icon="emojione:red-circle"
                    data-inline="false"
                  ></span>{" "}
                  &nbsp;{" "}
                  <span
                    className="iconify"
                    data-icon="twemoji:yellow-circle"
                    data-inline="false"
                  ></span>{" "}
                  &nbsp;{" "}
                  <span
                    className="iconify"
                    data-icon="twemoji:green-circle"
                    data-inline="false"
                  ></span>
                </div>
                <div
                  className="card-body font-trebuchet text-justify ml-3 mr-3"
                  style={{
                      height: "25ch",
                    fontSize: "132%",
                    lineHeight: "200%",
                      minWidth: "35ch"
                  }}
                >
                    <h1>Let's Connect 😊</h1>
                  <p>If you'd like to</p>
                    <div
                        style={{
                            height: "5ch",
                        }}
                    >
                        <ContactTypeAnimation/>
                        {/* ask me about bold career transitions", "the coding bootcamp experience", "propose a collaboration on an intriguing project", "just say hey :) */}
                    </div>
                    <p>- Feel free to drop a message.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4 mb-5 center">
          <Form />
        </div>
        </div>
        </div>
      </section>
    );
  }
}
